class HeaderSubnavCarousel extends HTMLElement {
  constructor() {
    super();

    this.carouselClass = 'header-subnav__carousel'
  }

  connectedCallback() {
    this.setupCarousel();
  }

  updateCarouselStatus() {
    const list = this.querySelector('.header-subnav__list');
    const offset = 1;

    if (!this || !list) {
      return;
    }

    if (list.scrollWidth > list.clientWidth) {
      this.classList.toggle(`${this.carouselClass}--has-previous`, list.scrollLeft > offset);
      this.classList.toggle(`${this.carouselClass}--has-next`, list.scrollLeft + list.clientWidth < list.scrollWidth - offset);
    }
  }

  setupCarousel() {
    const list = this.querySelector('.header-subnav__list');
    const initClass = `${this.carouselClass}--is-initialized`;

    if (this.classList.contains(initClass) || !list) {
      return;
    }

    this.classList.add(initClass);

    const prevButton = document.createElement('button');
    prevButton.className = `${this.carouselClass}-button ${this.carouselClass}-button--previous`;
    prevButton.setAttribute('aria-label', 'Previous');

    const nextButton = document.createElement('button');
    nextButton.className = `${this.carouselClass}-button ${this.carouselClass}-button--next`;
    nextButton.setAttribute('aria-label', 'Next');

    this.appendChild(prevButton);
    this.appendChild(nextButton);

    const getVisibleItemWidth = () => {
      const items = list.querySelectorAll('.header-subnav__item');

      for (const item of items) {
        if (item.offsetParent !== null) {
          return item.offsetWidth;
        }
      }

      return 0;
    }

    const updateStatus = () => this.updateCarouselStatus();

    prevButton.addEventListener('click', () => {
      const itemWidth = getVisibleItemWidth();
      list.scrollLeft -= itemWidth;
      setTimeout(updateStatus, 500);
    });

    nextButton.addEventListener('click', () => {
      const itemWidth = getVisibleItemWidth();
      list.scrollLeft += itemWidth;
      setTimeout(updateStatus, 500);
    });

    list.addEventListener('scroll', updateStatus);
    this.updateCarouselStatus();
  }
}

customElements.define('header-subnav-carousel', HeaderSubnavCarousel);